export const subscriptions = [
  {
    priceId: process.env.REACT_APP_STRIPE_MONTHLY_SUBSCRIPTION_ID,
    id: process.env.REACT_APP_STRIPE_MONTHLY_SUBSCRIPTION_ID,
    price: 9.99,
    name: "Fruition Monthly",
    description: "Billed monthly",
  },
];
